import painUpperBack from '@shared/assets/img/pain_upper_back_female.svg'
import painLowerBack from '@shared/assets/img/pain_lower_back_female.svg'
import painDurationBelow6Weeks from '@shared/assets/img/pain_duration_below_6_weeks.svg'
import painDuration6To12Weeks from '@shared/assets/img/pain_duration_6_to_12_weeks.svg'
import painDurationOver12Weeks from '@shared/assets/img/pain_duration_over_12_weeks.svg'
import previousTreatmentYes from '@shared/assets/img/previous_treatment_yes.svg'
import previousTreatmentNo from '@shared/assets/img/previous_treatment_no.svg'

// "Other" carries no nameable goal, so the renewal flow treats it the same as
// no goal at all and asks the generic therapy-helpfulness question instead.
export const GOAL_KEY_OTHER = 'other'

export const PAIN_LOCATION_OPTIONS = [
  {
    key: 'upper-back',
    label: 'b2b_self_test_pain_location_option_upper_back',
    image: painUpperBack,
    imageWidth: 335,
    imageHeight: 212,
    reflectionTitle:
      'eu__self_test_reflection__pain_location__upper_back__title',
    reflectionBody: 'eu__self_test_reflection__pain_location__upper_back__body',
  },
  {
    key: 'lower-back',
    label: 'b2b_self_test_pain_location_option_lower_back',
    image: painLowerBack,
    imageWidth: 335,
    imageHeight: 212,
    reflectionTitle:
      'eu__self_test_reflection__pain_location__lower_back__title',
    reflectionBody: 'eu__self_test_reflection__pain_location__lower_back__body',
  },
]

export const PAIN_DURATION_OPTIONS_MSK_EU = [
  {
    value: 'less-than-6-weeks',
    label: 'b2b_self_test_pain_duration_option_below_6_weeks',
    image: painDurationBelow6Weeks,
    imageWidth: 335,
    imageHeight: 259,
    reflectionTitle:
      'eu__self_test_reflection__pain_duration__below_6_weeks__title',
    reflectionBody:
      'eu__self_test_reflection__pain_duration__below_6_weeks__body',
  },
  {
    value: '6-to-12-weeks',
    label: 'b2b_self_test_pain_duration_option_6_to_12_weeks',
    image: painDuration6To12Weeks,
    imageWidth: 335,
    imageHeight: 259,
    reflectionTitle:
      'eu__self_test_reflection__pain_duration__6_to_12_weeks__title',
    reflectionBody:
      'eu__self_test_reflection__pain_duration__6_to_12_weeks__body',
  },
  {
    value: '12-to-24-weeks',
    label: 'b2b_self_test_pain_duration_option_over_12_weeks',
    image: painDurationOver12Weeks,
    imageWidth: 335,
    imageHeight: 259,
    reflectionTitle:
      'eu__self_test_reflection__pain_duration__over_12_weeks__title',
    reflectionBody:
      'eu__self_test_reflection__pain_duration__over_12_weeks__body',
  },
]

export const PAIN_DURATION_OPTIONS_OTHER = [
  {
    value: 'less-than-4-weeks',
    label: 'b2b_self_test_pain_duration_option_below_4_weeks',
    image: painDurationBelow6Weeks,
    imageWidth: 335,
    imageHeight: 259,
    reflectionTitle:
      'eu__self_test_reflection__pain_duration__below_6_weeks__title',
    reflectionBody:
      'eu__self_test_reflection__pain_duration__below_6_weeks__body',
  },
  {
    value: '4-to-12-weeks',
    label: 'b2b_self_test_pain_duration_option_4_to_12_weeks',
    image: painDuration6To12Weeks,
    imageWidth: 335,
    imageHeight: 259,
    reflectionTitle:
      'eu__self_test_reflection__pain_duration__6_to_12_weeks__title',
    reflectionBody:
      'eu__self_test_reflection__pain_duration__6_to_12_weeks__body',
  },
  {
    value: '12-to-24-weeks',
    label: 'b2b_self_test_pain_duration_option_3_to_6_months',
    image: painDurationOver12Weeks,
    imageWidth: 335,
    imageHeight: 259,
    reflectionTitle:
      'eu__self_test_reflection__pain_duration__over_12_weeks__title',
    reflectionBody:
      'eu__self_test_reflection__pain_duration__over_12_weeks__body',
  },
  {
    value: 'more-than-24-weeks',
    label: 'b2b_self_test_pain_duration_option_over_24_weeks',
    image: painDurationOver12Weeks,
    imageWidth: 335,
    imageHeight: 259,
    reflectionTitle:
      'eu__self_test_reflection__pain_duration__over_12_weeks__title',
    reflectionBody:
      'eu__self_test_reflection__pain_duration__over_12_weeks__body',
  },
]

// `value` is what the API takes; `key` is what the screens and the
// reflection compare against the confirmed store value.
export const PREVIOUS_TREATMENT_OPTIONS = [
  {
    key: true,
    value: 'previous-treatment-true',
    label: 'eu__self_test_previous_treatment__yes',
    image: previousTreatmentYes,
    imageWidth: 315,
    imageHeight: 259,
    reflectionTitle: null,
    reflectionBody: 'eu__self_test_reflection__previous_treatment__yes__body',
  },
  {
    key: false,
    value: 'previous-treatment-false',
    label: 'eu__self_test_previous_treatment__no',
    image: previousTreatmentNo,
    imageWidth: 318,
    imageHeight: 259,
    reflectionTitle: null,
    reflectionBody: 'eu__self_test_reflection__previous_treatment__no__body',
  },
]

// The therapy goals offered at SelfTestGoal, submitted as the self-test `goal`
// answer and as the renewal's `referenced_goal_key`. Hyphenated like every other
// answer value the backend takes, and like the self_test_goal it sends back.
export const GOAL_OPTIONS = [
  { value: 'relieve-pain', label: 'eu__self_test_goal__option_relieve_pain' },
  {
    value: 'fewer-pain-meds',
    label: 'eu__self_test_goal__option_fewer_pain_meds',
  },
  {
    value: 'bring-movement-back',
    label: 'eu__self_test_goal__option_bring_movement_back',
  },
  {
    value: 'build-strength',
    label: 'eu__self_test_goal__option_build_strength',
  },
  { value: 'sleep-better', label: 'eu__self_test_goal__option_sleep_better' },
  {
    value: 'become-more-mobile',
    label: 'eu__self_test_goal__option_become_more_mobile',
  },
  { value: 'prevent-pain', label: 'eu__self_test_goal__option_prevent_pain' },
  { value: 'avoid-surgery', label: 'eu__self_test_goal__option_avoid_surgery' },
  { value: GOAL_KEY_OTHER, label: 'eu__self_test_goal__option_other' },
]
